package fr.frux.feature.map

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

/**
 * Visibilite reelle de la carte a l'ecran (#515, ADR 0029), signalee par `MapSurface` — seule
 * composable toujours vivante (ADR 0009) — avec le meme booleen `interactive` qu'elle recoit deja
 * de l'hote (`Route.isMapInteractive`). `MapScreen` seul ne suffit pas : il n'est pas recompose
 * quand un panneau `MapZone` est au sommet de la pile en grand ecran, alors que la carte reste
 * visible a cote. Extrait de `MapViewModel` (ratchet detekt LargeClass), meme patron que
 * `LocationController`/`NearestDistanceLoader` dans ce module : collecte [changes] elle-meme,
 * `markStale` marque toujours le lot perime, `reloadIfVisible` ne recharge que si [isVisible].
 */
internal class MapVisibilityTracker(
    scope: CoroutineScope,
    changes: Flow<Unit>,
    private val markStale: () -> Unit,
    private val reloadIfVisible: () -> Unit,
) {
    private val _visible = MutableStateFlow(false)

    /** Meme valeur que [isVisible], observable : le suivi de position s'y abonne (#734). */
    val visible: StateFlow<Boolean> = _visible.asStateFlow()

    val isVisible: Boolean get() = _visible.value

    init {
        scope.launch {
            changes.collect {
                markStale()
                if (isVisible) reloadIfVisible()
            }
        }
    }

    fun onVisibilityChanged(visible: Boolean) {
        _visible.value = visible
    }
}
